import React from 'react';

import "./manning-online-lists.scss";
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { TaggedProductList } from '../../../ts/components/common/taggedProductList/TaggedProductList';
import { ProductCard } from '../../../ts/components/common/productCard/ProductCard';
import { ReadingList } from '../../../ts/components/common/readingList/ReadingList';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { TaggedProductListWithDetails } from '../taggedProductListWithDetails/TaggedProductListWithDetails';
import ValueUtils from '../../../ts/utils/ValueUtils';
import { IReadingList } from '../../models/ReadingList';

TimeAgo.setDefaultLocale(en.locale)
TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-US');

export interface IProps {
    store: ManningOnlineStore;
}

export interface IState {
    isReordering: boolean;
}

export class ManningOnlineLists extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isReordering: false
        };

        this.onReorder = this.onReorder.bind(this);
        this.onMoveUp = this.onMoveUp.bind(this);
        this.onMoveDown = this.onMoveDown.bind(this);
    }

    public render(){
        const displayedLists = this.props.store.getDisplayedReadingLists();
        return <div className="manning-online-lists-root">
                    { displayedLists.map(it => {
                        const timeAgo = this.getTimeAgo(it.lastUpdated);
                        let subtitle = timeAgo ? `last title added ${timeAgo}` : "";
                        return <ReadingList key={it.id} 
                                            readingList={it} 
                                            store={this.props.store}
                                            pretitle="my list"
                                            subtitle={subtitle} 
                                            canAddProduct={true}
                                            canReorder={true}
                                            isReordering={this.state.isReordering}
                                            onReorder={this.onReorder}
                                            onMoveUp={this.onMoveUp}
                                            onMoveDown={this.onMoveDown}/>
                    })}
                    { displayedLists != null && displayedLists.length > 1
                    ? <h4 className="manning-online-section-title new-reading-list-header" onClick={() => this.props.store.requestNewReadingListCreationModal()}> 
                         <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black"/>
                         </svg> &nbsp;
                         new reading list
                      </h4> : null }
                    
                    {this.renderRecentReading()}
                    {this.renderRecommendedReading()}
                    {this.renderOwnedReading()}
               </div>
    }

    private renderRecentReading(){
        const productList = this.props.store.catalogState.recentReading;
        if(!productList || productList.length == 0) { return null; }

        const firstProduct = productList[0]
        
        return <TaggedProductList key={"recent reading"} tag={"recent reading"} 
                                  showSlideArrows={true}
                                  showMoreInfoCardOnClick={false}
                                  store={this.props.store}
                                  subtitle={!firstProduct.isDummy ? `${productList.length} title${productList.length > 1 ? "s" : ""}` : "&nbsp;"}>
                    { productList.map(it => 
                        <ProductCard key={it.id}
                                     onHoverLabel={!it.isDummy ? "resume" : ""}
                                     productDescription={it} 
                                     coverPlaceholder={this.props.store.coverPlaceholder}
                                     wideCoverPlaceholder={this.props.store.wideCoverPlaceholder}
                                     showPercentage={true}
                                     percentageRead={it.percentageRead}
                                     data={`${it.manningId}`}
                                     onDragStart={this.props.store.catalogState.coversAreDraggable ? this.props.store.onProductCoverDragStart : null}/>)}
                </TaggedProductList>
    }

    private renderRecommendedReading(){
        const productList = this.props.store.catalogState.recommendedReading;
        if(!productList) { return null; }

        return <TaggedProductListWithDetails key={"recommended"}
                                             subtitle={"based on the topics you follow"}
                                             store={this.props.store} 
                                             defaultOnHoverLabel="read"
                                             taggedProductList={{
                                                 title: "recommended",
                                                 products: productList,
                                                 lastUpdated: ValueUtils.getDateAsString(new Date())
                                            }}/>
    }

    private renderOwnedReading(){
        const ownedList = this.props.store.catalogState.ownedProducts;
        if(!ownedList || ownedList.length == 0) { return null; }

        const firstProduct = ownedList[0];

        return <TaggedProductListWithDetails key={"owned"}
                                             subtitle={!firstProduct.isDummy ? `${ownedList.length} products` : "&nbsp;"}
                                             store={this.props.store} 
                                             defaultOnHoverLabel="read"
                                             taggedProductList={{
                                                 title: "your products",
                                                 products: ownedList,
                                                 lastUpdated: ValueUtils.getDateAsString(ownedList[0].licenseDate)
                                            }}/>
    }

    private getTimeAgo(date: string){
        try{
            const label = timeAgo.format(new Date(date));
            if(label == "in NaN years") { return ""; }
            if(label == "1 day ago") { return "yesterday"; }

            return label;
        }
        catch(e){
            console.error(e);
            return "";
        }
    }

    private onReorder(){
        this.setState({
            isReordering: !this.state.isReordering
        });
    }

    private onMoveUp(readingList: IReadingList){
        this.props.store.readingListStore.moveReadingListUp(readingList);
    }

    private onMoveDown(readingList: IReadingList){
        this.props.store.readingListStore.moveReadingListDown(readingList);
    }
}